module.exports = __webpack_public_path__ + "static/img/new_03.945fccd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_03.jpg
// module id = 8Ja5
// module chunks = 0